if($('#contact-content-finance').length) {

    if (window.helpers.getQueryVariable('contact-broker') && $('#selected-contact-broker').length) {
        let brokerName = $('#selected-contact-broker').val(),
            select = $('.financing-gravity-form-container').find('select').first(),
            values = select.find('option');

        values.each(function () {
            if ($(this).val() === brokerName) select.val($(this).val());
        });

        if(window.helpers.getQueryVariable('same-page') == "true") {
            $('html, body').animate({ scrollTop: $('#contact-content-finance')[0].offsetTop - $('.primary-nav').outerHeight() }, ($(window).width() >= 768) ? 500 : 0);
        }

    }

    $('.contact-broker-on-page').on('click', function () {
        let selectedBroker = $(this).data('broker-name'),
            select = $('.financing-gravity-form-container').find('select').first(),
            values = select.find('option');

        values.each(function () {
            if ($(this).val() === selectedBroker) select.val($(this).val());
            $('html, body').animate({ scrollTop: $('#contact-content-finance')[0].offsetTop - $('.primary-nav').outerHeight() }, ($(window).width() >= 768) ? 500 : 0);
        });
    });

}
